import { render, staticRenderFns } from "./Notenstrukturliste.vue?vue&type=template&id=60fdbbc2"
import script from "./Notenstrukturliste.vue?vue&type=script&lang=js"
export * from "./Notenstrukturliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports